export default {
  map_unavailable: 'Harta nu a putut fi încărcată. Reîncarcă pagina pentru a încerca din nou.',
  stubs: {
    name: 'Zonă de livrare {{number}}',
  },
  buttons: {
    add_new_zone: 'Adaugă zonă nouă',
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea zonelor de livrare',
  },
};
